export default __webpack_public_path__ + "static/media/555.a69606bf.png";